module.exports = __webpack_public_path__ + "img/arrow_forward.b34c4020.svg";